import {Helmet, HelmetProvider} from "react-helmet-async";
import {absoluteUrl, imageUrl} from "utils/url";
import {gaHeadScript} from "utils/ga";

const Head = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta name="keywords" content="網路拍賣,競標,購物,奇摩拍賣,拍賣網,日本代標,代買,代購,代拍,日雅,日本直送,一元起標"/>
        <meta name="description" content="Buyee代替客人將在Yahoo! JAPAN Auction中成功得標的商品運送到海外。24小時自助下標系統一站式現地專業代bid代拍代購日本各類商品產品簡單方便迅速快捷絕不取巧"/>
        <link rel="apple-touch-icon" href={imageUrl('cobrand/touch-icon.png')}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Buyee X Yahoo奇摩拍賣－提供一站式最全面最專業現地Yahoo! JAPAN Auction代bid代拍代購服務"/>
        <meta property="og:description" content="Buyee代替客人將在Yahoo! JAPAN Auction中成功得標的商品運送到海外。24小時自助下標系統一站式現地專業代bid代拍代購日本各類商品產品簡單方便迅速快捷絕不取巧"/>
        <meta property="og:image" content={imageUrl('cobrand/common/ogp.png')}/>
        <meta property="og:url" content={absoluteUrl('cobrand')}/>
        <meta property="og:site_name" content="Buyee"/>
        <meta name="twitter:card" content="summary"/>
        <meta name="twitter:site" content="@Buyee"/>
        <meta name="twitter:title" content="Buyee X Yahoo奇摩拍賣－提供一站式最全面最專業現地Yahoo! JAPAN Auction代bid代拍代購服務"/>
        <meta name="twitter:description" content="Buyee代替客人將在Yahoo! JAPAN Auction中成功得標的商品運送到海外。24小時自助下標系統一站式現地專業代bid代拍代購日本各類商品產品簡單方便迅速快捷絕不取巧"/>
        <meta name="twitter:image" content={imageUrl('cobrand/common/ogp.png')}/>
        <title>Buyee X Yahoo奇摩拍賣－提供一站式最全面最專業現地Yahoo! JAPAN Auction代bid代拍代購服務</title>
        {gaHeadScript()}
      </Helmet>
    </HelmetProvider>
  );
}

export default Head;
